import type { ReactNode } from "react";
import React from "react";

interface IFooterDataDisclaimerProps extends React.HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export default function FooterDataDisclaimer({ children, ...props }: IFooterDataDisclaimerProps) {
  return (
    <div className="flex justify-center" {...props}>
      <div className="flex items-center space-x-2 rounded-md border border-slate-300 bg-slate-100 p-3 lg:rounded-full lg:px-2 lg:py-2">
        <div>
          <InformationCircleIcon className="hidden h-5 w-5 text-slate-600 lg:inline-flex" />
        </div>
        <p className="m-0 text-sm tracking-wider text-slate-500">{children}</p>
      </div>
    </div>
  );
}

function InformationCircleIcon(props: React.SVGProps<any>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className="h-6 w-6"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
      />
    </svg>
  );
}
